import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'

// Install required rule and message.
extend('required', {
  ...required,
  message: en.messages.required
})



// WEBPACK FOOTER //
// ./src/vee-validate.js